import enumBase from './EnumBase';

export default class ApiPermissions extends enumBase {
  /**
   *  wildcard permission (all permissions)
   */
  static ALL = '*';

  /**
   *  Envelopes permissions
   */
  static ENVELOPE_VIEW = 'envelope-view';
  static ENVELOPE_CREATE = 'envelope-create';
  static ENVELOPE_SEND = 'envelope-send';
  static ENVELOPE_UPDATE = 'envelope-update';
  static ENVELOPE_DELETE = 'envelope-delete';
  static ENVELOPE_REVIEW_UPDATE = 'envelope-review-update';

  /**
   *  Organization Users permissions
   */
  static USER_VIEW = 'user-view';
  static USER_MANAGE = 'user-manage';
  static USER_DELETE = 'user-delete';

  /**
   *  Storage permissions
   */
  static STORAGE_VIEW = 'storage-view';
  static STORAGE_CREATE = 'storage-create';
  static STORAGE_UPDATE = 'storage-update';
  static STORAGE_DELETE = 'storage-delete';

  /**
   *  Developer Applications permissions
   */
  static CLIENT_VIEW = 'client-view';
  static CLIENT_CREATE = 'client-create';
  static CLIENT_UPDATE = 'client-update';
  static CLIENT_DELETE = 'client-delete';

  /**
   * Integration permissions
   */
  static INTEGRATION_VIEW = 'integration-view';
  static INTEGRATION_CREATE = 'integration-create';
  static INTEGRATION_UPDATE = 'integration-update';
  static INTEGRATION_DELETE = 'integration-delete';

  /**
   *  Teams (organization and share) permissions
   */
  static TEAM_VIEW = 'team-view';
  static TEAM_CREATE = 'team-create';
  static TEAM_UPDATE = 'team-update';
  static TEAM_DELETE = 'team-delete';

  /**
   *  Organization config permissions
   */
  static WORKSPACE_MANAGE = 'workspace-manage';

  /**
   *  Billing (Plan) permissions
   */
  static BILLING_VIEW = 'billing-view';
  static BILLING_MANAGE = 'billing-manage';

  /**
   *  Backup permissions
   */
  static BACKUP_VIEW = 'backup-view';
  static BACKUP_CREATE = 'backup-create';

  /**
   *  Default Organization Member permissions (is_owner = false)
   */
  static memberValues = [
    this.ENVELOPE_VIEW,
    this.ENVELOPE_CREATE,
    this.ENVELOPE_UPDATE,
    this.ENVELOPE_DELETE,
    this.ENVELOPE_SEND,
    this.STORAGE_VIEW,
    this.STORAGE_CREATE,
    this.STORAGE_DELETE,
    this.STORAGE_UPDATE,
    this.TEAM_VIEW,
    this.BILLING_VIEW,
  ];

  /**
   * Admin has all API permissions (organization owner);
   */
  static values = [
    this.ALL,
    this.BACKUP_CREATE,
    this.BACKUP_VIEW,
    this.WORKSPACE_MANAGE,
    this.BILLING_MANAGE,
    this.BILLING_VIEW,
    this.TEAM_VIEW,
    this.TEAM_CREATE,
    this.TEAM_UPDATE,
    this.TEAM_DELETE,
    this.INTEGRATION_CREATE,
    this.INTEGRATION_VIEW,
    this.INTEGRATION_UPDATE,
    this.INTEGRATION_DELETE,
    this.CLIENT_CREATE,
    this.CLIENT_VIEW,
    this.CLIENT_UPDATE,
    this.CLIENT_DELETE,
    this.STORAGE_CREATE,
    this.STORAGE_VIEW,
    this.STORAGE_DELETE,
    this.STORAGE_UPDATE,
    this.USER_DELETE,
    this.USER_MANAGE,
    this.USER_VIEW,
    this.ENVELOPE_CREATE,
    this.ENVELOPE_VIEW,
    this.ENVELOPE_DELETE,
    this.ENVELOPE_UPDATE,
    this.ENVELOPE_SEND,
    this.ENVELOPE_REVIEW_UPDATE,
  ];
}
